export default __webpack_public_path__ + "build/85da472b2a43783e6dcd5e62434d910f.jpg";